<div class="container">
  <form [formGroup]="formGroup" (ngSubmit)="handleSubmit()">
    <app-request-title></app-request-title>

    <app-workspace-state
      [workspaceStateDraftVersion]="workspaceStateDraftVersion"
      [workspaceStateId]="workspaceStateId"
      [getWorkspaceStateToSave]="getWorkspaceStateToSave"
      [workspaceStateSaveValidator]="
        validateIfRequestModeIsSelectedAndShowAlert
      "
      [workspaceStateLoadValidator]="
        validateIfRequestModeIsSelectedAndShowAlert
      "
      [requestMode]="getRequestModeValue()"
      [borderClass]="'card-border-color-from-db'"
      [backgroundClass]="'card-header-color-from-db'"
      [buttonClass]="'btn-color-from-db'"
      (workspaceStateLoaded)="handleLoadWorkspaceResponse($event)"
    ></app-workspace-state>

    @let investorDetailsFormGroupAlertShouldBeVisible =
      submitted && !isInvestorDetailsFormGroupValid();
    <section>
      <div
        class="card mb-4"
        [ngClass]="
          investorDetailsFormGroupAlertShouldBeVisible
            ? 'border-danger border-2'
            : 'card-border-color-from-db'
        "
      >
        <div class="card-header card-header-color-from-db">
          {{ 'TREES_AND_SHRUBS_REMOVAL_NOTIFICATION.CLIENT_DATA' | translate }}
        </div>

        <div class="card-body">
          <app-investor-details
            [investorDetailsFromGroup]="getInvestorDetailsFormGroup()"
            [isEmailRequired]="false"
            [isEPUAPAddressVisible]="true"
            [isPeselVisible]="false"
            [isIdVisible]="false"
            [isPhoneNumberRequired]="false"
            [disabledNaturalPersonData]="true"
            [wasFormValidated]="submitted"
            [loggedUserAddressEditableByExternalForm]="true"
          ></app-investor-details>
        </div>

        @if (investorDetailsFormGroupAlertShouldBeVisible) {
          <div class="card-footer">
            <div class="alert alert-danger my-2">
              {{ 'FIELDS_REQUIRED' | translate }}
            </div>
          </div>
        }
      </div>
    </section>

    <gk-request-mode
      #requestModeComponent
      [formGroup]="formGroup"
      [portalId]="portalId"
      [submitted]="submitted"
      [requestModesUrl]="
        '/api/interesant/wniosek/zgloszenieZlomuWywrotuDrzewaKrzewu/zaswiadczenie/tryb'
      "
      [borderClass]="'card-border-color-from-db'"
      [backgroundClass]="'card-header-color-from-db'"
      [buttonClass]="'btn-color-from-db'"
    ></gk-request-mode>

    @let isNewRemovalNotificationMode = this.isNewRemovalNotificationMode();
    @let isNoObjectionCertificateRequestMode =
      this.isNoObjectionCertificateRequestMode();
    @if (isNewRemovalNotificationMode) {
      <section>
        @let mapSectionAlertShouldBeVisible = submitted && !isMapSectionValid();
        <div
          class="card mb-4"
          [ngClass]="
            mapSectionAlertShouldBeVisible
              ? 'border-danger border-2'
              : 'card-border-color-from-db'
          "
        >
          <div class="card-header card-header-color-from-db">
            {{
              'TREES_AND_SHRUBS_REMOVAL_NOTIFICATION.MAP_LOCATION' | translate
            }}
          </div>

          <div class="card-body">
            <gk-map
              [mapState]="mapState"
              (dispatch)="handleMapAction($event)"
            ></gk-map>

            <div class="my-2">
              @if (mapState.mapObjectTablesState[0].mapObjects.length) {
                <gk-map-object-table
                  [mapState]="mapState"
                  [mapObjectTableStateIndex]="0"
                  (dispatch)="handleMapAction($event)"
                ></gk-map-object-table>
              }
            </div>
          </div>
          @if (mapSectionAlertShouldBeVisible) {
            <div class="card-footer">
              <div class="alert alert-danger my-2">
                {{ 'LAND_PARCEL_AND_RANGE_REQUIRED' | translate }}
              </div>
            </div>
          }
        </div>
      </section>

      @let someTreesOrShrubsFormGroups = areSomeTreesOrShrubsFormGroups();

      <section class="px-4 pt-4 border card-border-color-from-db rounded mb-4">
        <h2 class="mb-4">
          {{ 'TREES_AND_SHRUBS_REMOVAL_NOTIFICATION.TREES_LIST' | translate }}
        </h2>

        <ng-container [formArrayName]="controlName.Trees">
          @for (
            treeFormGroup of getTreesFormArray().controls;
            track i;
            let i = $index
          ) {
            <section [formGroupName]="i">
              <div
                class="card mb-4"
                [ngClass]="
                  checkTreeFormGroupValidAndFormValidated(i)
                    ? 'border-danger border-2'
                    : 'card-border-color-from-db'
                "
              >
                <div class="card-header card-header-color-from-db">
                  {{ 'TREES_AND_SHRUBS_REMOVAL_NOTIFICATION.TREE' | translate }}
                  #{{ i + 1 }}
                  <button
                    (click)="deleteTreeFormControl(i)"
                    type="button"
                    aria-label="minus"
                    title="minus"
                    class="btn btn-danger fa fa-minus float-end"
                  ></button>
                </div>
                <div class="card-body">
                  <div class="row">
                    <div class="col-4">
                      <label
                        [attr.for]="
                          fellingObjectsControlName.InventoryNumber +
                          '-tree-' +
                          i
                        "
                      >
                        {{
                          'TREES_AND_SHRUBS_REMOVAL_NOTIFICATION.INVENTORY_NUMBER'
                            | translate
                        }}
                        <sup>1</sup>
                      </label>
                      <input
                        type="text"
                        [name]="
                          fellingObjectsControlName.InventoryNumber +
                          '-tree-' +
                          i
                        "
                        [id]="
                          fellingObjectsControlName.InventoryNumber +
                          '-tree-' +
                          i
                        "
                        class="form-control form-control-sm required"
                        aria-required="true"
                        [formControlName]="
                          fellingObjectsControlName.InventoryNumber
                        "
                      />
                      @if (
                        shouldShowRequiredAlert(
                          getTreeInventoryNumberFormControl(i)
                        )
                      ) {
                        <div class="alert alert-danger">
                          {{ 'FIELD_REQUIRED' | translate }}
                        </div>
                      }
                    </div>
                    <div class="col-4">
                      <label
                        [attr.for]="
                          fellingObjectsControlName.SpeciesName + '-tree-' + i
                        "
                      >
                        {{
                          'TREES_AND_SHRUBS_REMOVAL_NOTIFICATION.SPECIES_NAME'
                            | translate
                        }}
                        <sup>2</sup>
                      </label>
                      <input
                        type="text"
                        [name]="
                          fellingObjectsControlName.SpeciesName + '-tree-' + i
                        "
                        [id]="
                          fellingObjectsControlName.SpeciesName + '-tree-' + i
                        "
                        class="form-control form-control-sm required"
                        aria-required="true"
                        [formControlName]="
                          fellingObjectsControlName.SpeciesName
                        "
                      />
                      @if (
                        shouldShowRequiredAlert(
                          getTreeSpeciesNameFormControl(i)
                        )
                      ) {
                        <div class="alert alert-danger">
                          {{ 'FIELD_REQUIRED' | translate }}
                        </div>
                      }
                    </div>
                    <div class="col-4">
                      <label
                        [attr.for]="
                          fellingObjectsControlName.TrunkCircumference + '-' + i
                        "
                      >
                        {{
                          'TREES_AND_SHRUBS_REMOVAL_NOTIFICATION.TRUNK_CIRCUMFERENCE'
                            | translate
                        }}
                        <sup>3</sup>
                      </label>
                      <div class="input-group input-group-sm">
                        <input
                          type="number"
                          [name]="
                            fellingObjectsControlName.TrunkCircumference +
                            '-' +
                            i
                          "
                          [id]="
                            fellingObjectsControlName.TrunkCircumference +
                            '-' +
                            i
                          "
                          class="form-control required"
                          aria-required="true"
                          [formControlName]="
                            fellingObjectsControlName.TrunkCircumference
                          "
                        />
                        <span class="input-group-text">cm</span>
                      </div>
                      @if (
                        shouldShowRequiredAlert(
                          getTreeTrunkCircumferenceFormControl(i)
                        )
                      ) {
                        <div class="alert alert-danger">
                          {{ 'FIELD_REQUIRED' | translate }}
                        </div>
                      }
                    </div>
                  </div>
                </div>
              </div>
            </section>
          }

          <section>
            <div
              class="card mb-4"
              [ngClass]="
                !someTreesOrShrubsFormGroups && submitted
                  ? 'border-danger border-2'
                  : 'card-border-color-from-db'
              "
            >
              <div class="card-header card-header-color-from-db">
                {{ 'TREES_AND_SHRUBS_REMOVAL_NOTIFICATION.TREE' | translate }}
              </div>

              <div class="card-body d-grid">
                <button
                  (click)="addTreeFormControl()"
                  type="button"
                  aria-label="plus"
                  title="plus"
                  class="btn btn-lg btn-color-from-db fa fa-plus"
                ></button>
              </div>

              @if (!someTreesOrShrubsFormGroups && submitted) {
                <div class="card-footer">
                  <div class="alert alert-danger my-2">
                    {{
                      'TREES_AND_SHRUBS_REMOVAL_NOTIFICATION.TREE_OR_SHRUB_REQUIRED'
                        | translate
                    }}
                  </div>
                </div>
              }
            </div>
          </section>
        </ng-container>

        @if (areSomeTreesFormGroups()) {
          <div
            class="jumbotron py-3"
            [innerHTML]="
              'TREES_AND_SHRUBS_REMOVAL_NOTIFICATION.TREES_LIST_INFO'
                | translate
            "
          ></div>
        }
      </section>

      <section class="px-4 pt-4 border card-border-color-from-db rounded mb-4">
        <h2 class="mb-4">
          {{ 'TREES_AND_SHRUBS_REMOVAL_NOTIFICATION.SHRUBS_LIST' | translate }}
        </h2>

        <ng-container [formArrayName]="controlName.Shrubs">
          @for (
            shrubFormGroup of getShrubsFormArray().controls;
            track i;
            let i = $index
          ) {
            <section [formGroupName]="i">
              <div
                class="card mb-4"
                [ngClass]="
                  checkShrubFormGroupValidAndFormValidated(i)
                    ? 'border-danger border-2'
                    : 'card-border-color-from-db'
                "
              >
                <div class="card-header card-header-color-from-db">
                  {{
                    'TREES_AND_SHRUBS_REMOVAL_NOTIFICATION.SHRUB' | translate
                  }}
                  #{{ i + 1 }}
                  <button
                    (click)="deleteShrubFormControl(i)"
                    type="button"
                    aria-label="minus"
                    title="minus"
                    class="btn btn-danger fa fa-minus float-end"
                  ></button>
                </div>
                <div class="card-body">
                  <div class="row">
                    <div class="col-4">
                      <label
                        [attr.for]="
                          fellingObjectsControlName.InventoryNumber +
                          '-shrub-' +
                          i
                        "
                      >
                        {{
                          'TREES_AND_SHRUBS_REMOVAL_NOTIFICATION.INVENTORY_NUMBER'
                            | translate
                        }}
                        <sup>1</sup>
                      </label>
                      <input
                        type="text"
                        [name]="
                          fellingObjectsControlName.InventoryNumber +
                          '-shrub-' +
                          i
                        "
                        [id]="
                          fellingObjectsControlName.InventoryNumber +
                          '-shrub-' +
                          i
                        "
                        class="form-control form-control-sm required"
                        aria-required="true"
                        [formControlName]="
                          fellingObjectsControlName.InventoryNumber
                        "
                      />
                      @if (
                        shouldShowRequiredAlert(
                          getShrubInventoryNumberFormControl(i)
                        )
                      ) {
                        <div class="alert alert-danger">
                          {{ 'FIELD_REQUIRED' | translate }}
                        </div>
                      }
                    </div>
                    <div class="col-4">
                      <label
                        [attr.for]="
                          fellingObjectsControlName.SpeciesName + '-shrub-' + i
                        "
                      >
                        {{
                          'TREES_AND_SHRUBS_REMOVAL_NOTIFICATION.SPECIES_NAME'
                            | translate
                        }}
                        <sup>2</sup>
                      </label>
                      <input
                        type="text"
                        [name]="
                          fellingObjectsControlName.SpeciesName + '-shrub-' + i
                        "
                        [id]="
                          fellingObjectsControlName.SpeciesName + '-shrub-' + i
                        "
                        class="form-control form-control-sm required"
                        aria-required="true"
                        [formControlName]="
                          fellingObjectsControlName.SpeciesName
                        "
                      />
                      @if (
                        shouldShowRequiredAlert(
                          getShrubSpeciesNameFormControl(i)
                        )
                      ) {
                        <div class="alert alert-danger">
                          {{ 'FIELD_REQUIRED' | translate }}
                        </div>
                      }
                    </div>
                    <div class="col-4">
                      <label
                        [attr.for]="
                          fellingObjectsControlName.ProjectionSurface + '-' + i
                        "
                      >
                        {{
                          'TREES_AND_SHRUBS_REMOVAL_NOTIFICATION.PROJECTION_SURFACE'
                            | translate
                        }}
                      </label>
                      <div class="input-group input-group-sm">
                        <input
                          type="number"
                          [name]="
                            fellingObjectsControlName.ProjectionSurface +
                            '-' +
                            i
                          "
                          [id]="
                            fellingObjectsControlName.ProjectionSurface +
                            '-' +
                            i
                          "
                          class="form-control required"
                          aria-required="true"
                          [formControlName]="
                            fellingObjectsControlName.ProjectionSurface
                          "
                        />
                        <span class="input-group-text">m²</span>
                      </div>
                      @if (
                        shouldShowRequiredAlert(
                          getShrubProjectionSurfaceFormControl(i)
                        )
                      ) {
                        <div class="alert alert-danger">
                          {{ 'FIELD_REQUIRED' | translate }}
                        </div>
                      }
                    </div>
                  </div>
                </div>
              </div>
            </section>
          }

          <section>
            <div
              class="card mb-4"
              [ngClass]="
                !areSomeTreesOrShrubsFormGroups() && submitted
                  ? 'border-danger border-2'
                  : 'card-border-color-from-db'
              "
            >
              <div class="card-header card-header-color-from-db">
                {{ 'TREES_AND_SHRUBS_REMOVAL_NOTIFICATION.SHRUB' | translate }}
              </div>

              <div class="card-body d-grid">
                <button
                  (click)="addShrubFormControl()"
                  type="button"
                  aria-label="plus"
                  title="plus"
                  class="btn btn-lg btn-color-from-db fa fa-plus"
                ></button>
              </div>

              @if (!areSomeTreesOrShrubsFormGroups() && submitted) {
                <div class="card-footer">
                  <div class="alert alert-danger my-2">
                    {{
                      'TREES_AND_SHRUBS_REMOVAL_NOTIFICATION.TREE_OR_SHRUB_REQUIRED'
                        | translate
                    }}
                  </div>
                </div>
              }
            </div>
          </section>
        </ng-container>

        @if (areSomeShrubsFormGroups()) {
          <div
            class="jumbotron py-3"
            [innerHTML]="
              'TREES_AND_SHRUBS_REMOVAL_NOTIFICATION.SHRUBS_LIST_INFO'
                | translate
            "
          ></div>
        }
      </section>
    }

    @if (isNoObjectionCertificateRequestMode) {
      <gk-case-select
        [submitted]="submitted"
        [formGroup]="formGroup"
        [url]="
          '/api/interesant/wniosek/zgloszenieZlomuWywrotuDrzewaKrzewu/zaswiadczenie/sprawy'
        "
      ></gk-case-select>
    }

    <app-proxy-details
      #proxyDetails
      [portalId]="portalId"
      [formGroup]="formGroup"
      [submitted]="submitted"
      [addressFormGroupBasedOnSelectControls]="true"
      [multiple]="true"
      [proxyTypeFormControlVisible]="true"
      [borderClass]="'card-border-color-from-db'"
      [backgroundClass]="'card-header-color-from-db'"
      [buttonClass]="'btn-color-from-db'"
    ></app-proxy-details>

    @if (isNewRemovalNotificationMode) {
      <app-multi-person-data
        #ownerDetailsComponent
        [portalId]="portalId"
        [formGroup]="formGroup"
        [controlName]="{
          DetailsCheckbox: controlName.OwnerOtherThanApplicant,
          DetailsArray: controlName.Owners,
        }"
        [submitted]="submitted"
        [addressFormGroupBasedOnSelectControls]="true"
        [multiple]="true"
        [proxyTypeFormControlVisible]="false"
        [borderClass]="'card-border-color-from-db'"
        [backgroundClass]="'card-header-color-from-db'"
        [buttonClass]="'btn-color-from-db'"
        [title]="'PARCEL_OWNER_DATA.TITLE'"
        [singleElementTitle]="'PARCEL_OWNER_DATA.OWNER'"
        [addButtonText]="'PARCEL_OWNER_DATA.ADD_OWNER'"
        [idPrefix]="'owner-'"
        [infoVisible]="false"
      ></app-multi-person-data>

      @let nonBusinessPurposesFormControlAlertShouldBeVisible =
        submitted && !isNonBusinessPurposesFormControlValid();
      <section>
        <div
          class="card mb-4"
          [ngClass]="
            nonBusinessPurposesFormControlAlertShouldBeVisible
              ? 'border-danger border-2'
              : 'card-border-color-from-db'
          "
        >
          <div class="card-header card-header-color-from-db">
            <label class="mb-0" [attr.for]="controlName.NonBusinessPurposes">
              {{
                'TREES_AND_SHRUBS_REMOVAL_NOTIFICATION.DECLARATION' | translate
              }}
            </label>
          </div>
          <div class="card-body">
            <div class="row">
              <div class="col-12">
                <mat-checkbox
                  [id]="controlName.NonBusinessPurposes"
                  [formControlName]="controlName.NonBusinessPurposes"
                >
                  {{
                    'TREES_AND_SHRUBS_REMOVAL_NOTIFICATION.DECLARATION_DESCRIPTION'
                      | translate
                  }}
                </mat-checkbox>
              </div>
            </div>
          </div>
          @if (nonBusinessPurposesFormControlAlertShouldBeVisible) {
            <div class="card-footer">
              <div class="alert alert-danger my-2">
                {{
                  'TREES_AND_SHRUBS_REMOVAL_NOTIFICATION.DECLARATION_REQUIRED'
                    | translate
                }}
              </div>
            </div>
          }
        </div>
      </section>
    }

    <gk-attachments
      [borderClass]="'card-border-color-from-db'"
      [backgroundClass]="'card-header-color-from-db'"
      [buttonClass]="'btn-color-from-db'"
      [portalId]="portalId"
      [submitted]="submitted"
      [requiredPowerOfAttorney]="proxyDetails.detailsVisible"
      [requiredRequestMode]="true"
      [requestMode]="getRequestModeValue()"
    >
    </gk-attachments>

    <app-request-reply-form
      [portalId]="portalId"
      [formGroup]="formGroup"
      [submitted]="submitted"
      [borderClass]="'card-border-color-from-db'"
      [backgroundClass]="'card-header-color-from-db'"
      [buttonClass]="'btn-color-from-db'"
    ></app-request-reply-form>

    <section class="my-2">
      <app-cautions
        [portalId]="portalId"
        [formGroup]="formGroup"
        [submitted]="submitted"
        [borderClass]="'card-border-color-from-db'"
        [backgroundClass]="'card-header-color-from-db'"
        [buttonClass]="'btn-color-from-db'"
      ></app-cautions>
    </section>

    <app-request-validation-info
      [shouldShowProvideFieldsAlert]="submitted && !isRequestValid()"
      [errorSubmitMessage]="errorSubmitMessage"
    ></app-request-validation-info>

    <section>
      <button type="submit" class="btn btn-color-from-db">
        {{ 'TREES_AND_SHRUBS_REMOVAL_NOTIFICATION.SUBMIT' | translate }}
      </button>

      <app-request-preview-button
        class="ms-2"
        [buttonClass]="'btn-color-from-db'"
        [getPreviewRequestBody]="getRequestBody"
        [previewRequestUrl]="
          '/api/interesant/wniosek/zgloszenieZamiaruUsunieciaKrzewuLubDrzewa/podglad'
        "
        [previewRequestValidation]="validateIfRequestModeIsSelectedAndShowAlert"
      ></app-request-preview-button>

      <app-request-cancel-button></app-request-cancel-button>

      <app-doc-sign-info
        [messageText]="docSignMsgTxt"
        [messageType]="docSignMsgType"
        [docSignUrl]="docSignUrl"
        [docSignPending]="docSignPending"
      ></app-doc-sign-info>

      <div class="mt-2"><app-form-legend></app-form-legend></div>
    </section>
  </form>
</div>

<ng-template #canDeactivateModal let-close="close">
  <div class="modal-header">
    <h4 class="modal-title">
      {{ 'MODAL_CAN_DEACTIVATE.ALERT_TITLE' | translate }}
    </h4>
  </div>

  <div class="modal-body">
    {{ 'MODAL_CAN_DEACTIVATE.DESCRIPTION' | translate }}
  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-light" (click)="close(false)">
      {{ 'MODAL_CAN_DEACTIVATE.CANCEL' | translate }}
    </button>

    <button type="button" class="btn btn-primary" (click)="close(true)">
      {{ 'MODAL_CAN_DEACTIVATE.CONFIRM' | translate }}
    </button>
  </div>
</ng-template>
